import {compose, withStateHandlers} from 'recompose';

export const withVoucherExtendInfo = compose(
  withStateHandlers(
    {
      voucherCode: null,
      extendDate: null,
    },
    {
      updateVoucherExtendInfo: ({voucherCode, extendDate}) => (
        newVoucherCode,
        extendDate,
      ) => ({
        voucherCode: newVoucherCode,
        extendDate: extendDate,
      }),
    },
  ),
);




// WEBPACK FOOTER //
// ./src/Account/Voucher/withVoucherExtendInfo.js